import { axiosInstance } from "@/configs/axiosConfig";

// Search Result API
export const getCompanySearchAPIData = (apiParams) => {
  return axiosInstance.get("companysearch", {
    params: apiParams,
  });
};


// TypeaheadSearch API
export const getTypeaheadSearchAPIData = (
  value: string,
  countrycode,
  languagecode
) => {
  const params = {
    countrycode: countrycode || "de",
    includeaddress: true,
    includecompanyinfocookie: true,
    languagecode: languagecode || "de",
    searchterm: value
  };

  return axiosInstance.get("typeaheadsearch", {
    params: params,
  });
};

// Popular companies API if Country is Switzerland
export const getPopularCompaniesAPIData = (
  countrycode: string,
  languagecode: string
) => {
  const params = {
    countrycode: countrycode,
    languagecode: languagecode
  };

  return axiosInstance.get("topcompanies", {
    params: params,
  });
};

// Company Profile API
export const getCompanyProfileData = (companyHashUrl, language, country) => {
  const params = {
    path: `https://www.dnb.com/${companyHashUrl}`,
    language,
    country
  };

  return axiosInstance.get("companyprofile", {
    params: params,
  });
};

// Industry Analysis API
export const getIndustryAnalysisData = (industrypage) => {
  const params = {
    industrypage,
  };

  return axiosInstance.get("industryanalysis", {
    params: params,
  });
};

// company information API
export const getCompanyInformationData = (requestBody) => {
  if (!requestBody.pageNumber) {
    requestBody.pageNumber = 1;
  }
  return axiosInstance.post("companyinformation", requestBody);
};

// Email API
export const getDnbDirectUtilForEmail = (
  countryIsoAlphaTwoCodeParameter,
  domain
) => {
  const params = {
    countryISOAlpha2Code: countryIsoAlphaTwoCodeParameter,
    url: domain,
  };

  return axiosInstance.get(`dnbdirectutil`, {
    params: params,
  });
};

// To get Industries Data
export const getIndustries = () => {
  return axiosInstance.get("industries");
}